import {
  FETCH_ALL_NEWSLETTERS,
  FETCH_NEWSLETTER,
  CREATE_NEWSLETTER,
  UPDATE_NEWSLETTER,
  DELETE_NEWSLETTER,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const newslettersReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_NEWSLETTERS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_NEWSLETTERS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_NEWSLETTERS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const newsletterReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_NEWSLETTER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_NEWSLETTER}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_NEWSLETTER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createNewsletterReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_NEWSLETTER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_NEWSLETTER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_NEWSLETTER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateNewsletterReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_NEWSLETTER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_NEWSLETTER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_NEWSLETTER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteNewsletterReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_NEWSLETTER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_NEWSLETTER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_NEWSLETTER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
